import styled from "styled-components";
import { colors } from "@sonder/ui/source/styled/theme";

export const PanelCardSectionHeader = styled.h5`
  color: ${colors.gray6};
  margin: 0.5rem 0;
`;
